import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociatePresenceRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-presence",
            component: () => loadView(import("./AssociatePresenceTable.vue")),
        },
    },
    create: {
        route: {
            path: "/associate-presence/create",
            component: () => loadView(import("./AssociatePresenceCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/associate-presence/:id",
            component: () => loadView(import("./AssociatePresenceDetail.vue")),
        },
        build(id: string) {
            return `/associate-presence/${id}`;
        },
    },
});
